import gsap from 'gsap';
import ScrollTrigger from "gsap/dist/ScrollTrigger.min";

gsap.registerPlugin(ScrollTrigger);

$(function() {
    const $body = document.querySelector('body'),
        $menuBtn = document.querySelectorAll('.js-menu-btn'),
        $navbarCollapse = document.querySelector('.js-navbar-collapse'),
        $navbarOverlay = document.querySelector('.js-navbar-overlay');

    $menuBtn.forEach(btn => {
        btn.addEventListener('click', () => {
            $body.classList.toggle('ov-hidden');
            $navbarCollapse.classList.toggle('open');
            $navbarOverlay.classList.toggle('open');

            if ($navbarCollapse.classList.contains('open')) {
                setTimeout(() => {
                    $menuBtn.forEach(btn => btn.querySelector('span').innerText = 'Close');
                }, 600);
            } else {
                setTimeout(() => {
                    $menuBtn.forEach(btn => btn.querySelector('span').innerText = 'Menu');
                }, 600);
            }
        });
    });

    const header = document.querySelector('.content > header.page-header');
    const sections = document.querySelectorAll('[data-midnight]');

    function changeHeader(sec) {
        if (sec.getAttribute("data-midnight") === "light") {
            header.classList.add("light-side");
        } else {
            header.classList.remove("light-side");
        }
    }

    sections.forEach((section) => {
        ScrollTrigger.create({
            trigger: section,
            start: "top 23",
            end: "bottom 23",
            markers: false,
            onEnter: () => changeHeader(section),
            onEnterBack: () => changeHeader(section),
        });
    });
});